"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * iq.ts - Image Quantization Library
 */
var ssim_1 = require("./ssim");
exports.ssim = ssim_1.ssim;
//# sourceMappingURL=index.js.map